export default "__VITE_ASSET__4fdc92b3__"